import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlechaverdeabajo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16.817,
	height: 9.823,
	viewBox: "0 0 16.817 9.823",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "flechaverde_abajo",
		"data-name": "flechaverde abajo",
		transform: "translate(159.641 3062.72)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Fill_3",
			"data-name": "Fill 3",
			d: "M16.612.205a.706.706,0,0,0-1,0L8.408,8.118,1.2.205a.706.706,0,0,0-1,0,.712.712,0,0,0,0,1l7.67,8.418a.674.674,0,0,0,.532.2.677.677,0,0,0,.533-.2l7.67-8.418a.714.714,0,0,0,0-1",
			transform: "translate(-159.641 -3062.72)",
			fill: "#5a8217"
		})
	})]
});
const ForwardRef = forwardRef(SvgFlechaverdeabajo);
export { ForwardRef as ReactComponent };
